module.exports = __webpack_public_path__ + "img/nx.190e75a2.png";